import { combineReducers } from "redux-immutable";

import ClassEnrollmentsStateSlice from "../models/ClassEnrollmentsStateSlice";
import enrollments, { childClassEnrollmentsReducer } from "./classEnrollments";
import classEnrollmentsMetaCrudStateReducer from "./meta";

export default combineReducers(
  {
    enrollments,
    childEnrollments: childClassEnrollmentsReducer,
    meta: classEnrollmentsMetaCrudStateReducer
  },
  () => new ClassEnrollmentsStateSlice() as any
);
